/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

// MAIN
import mainReducerParts from './appScanline';
import { initialState as mainInitialState } from './mainInitialState';

// ChartsSettings
import {
	reducerParts as chartsSettingsReducerParts,
	initialState as chartsSettingsInitialState
} from './slices/Charts';

// PageLoadState
import pageLoadStateReducerParts from './slices/AppStateV2PageLoadState/reducerParts';
import { initialState as pageLoadStateInitialState } from './slices/AppStateV2PageLoadState/initialState';

// AppStateV2
import appStateV2ReducerParts from './slices/AppStateV2/reducerParts';
import { initialState as appStateV2InitialState } from './slices/AppStateV2/initialState';

// ActionPlanStateV2
import actionPlanStateV2ReducerParts from './slices/ActionPlanStateV2/reducerParts';
import { initialState as actionPlanStateV2InitialState } from './slices/ActionPlanStateV2/initialState';

// ActionPlanReadings
import { ROOT_SLICE as ROOT_SLICE_ACTION_PLAN_READINGS } from './slices/ActionPlanReadings/constants';
import { initialState as ActionPlanReadingsInitialState } from './slices/ActionPlanReadings/initialState';
import ActionPlanReadingsReducerParts from './slices/ActionPlanReadings/reducerParts';

// ActionPlanSync
import { ROOT_SLICE as ROOT_SLICE_ACTION_PLAN_SYNC } from './slices/ActionPlanSync/constants';
import { initialState as ActionPlanSycnInitialState } from './slices/ActionPlanSync/initialState';
import ActionPlanSyncReducerParts from './slices/ActionPlanSync/reducerParts';

// ActionPlanMessages
import { ROOT_SLICE as ROOT_SLICE_ACTION_PLAN_MESSAGES } from './slices/ActionPlanMessages/constants';
import { initialState as ActionPlanMessagesInitialState } from './slices/ActionPlanMessages/initialState';
import ActionPlanMessagesReducerParts from './slices/ActionPlanMessages/reducerParts';

// StoreXYMinMax
import { ROOT_SLICE as ROOT_SLICE_STORE_YMIN_YMAX } from './slices/StoreXYMinMax/constants';
import { initialState as StoreXYMinMaxInitialState } from './slices/StoreXYMinMax/initialState';
import StoreXYMinMaxReducerParts from './slices/StoreXYMinMax/reducerParts';

// ReadingsStore
import { ROOT_SLICE as ROOT_SLICE_READINGS_STORE } from './slices/ReadingsStore/constants';
import { initialState as ReadingsStoreInitialState } from './slices/ReadingsStore/initialState';
import ReadingsStoreReducerParts from './slices/ReadingsStore/reducerParts';

// Reset State
import { resetScanlineState } from '../actions/app';
import { goodEnoughUUID } from '../utils/uuid';

const initialState = {
	...chartsSettingsInitialState,
	...pageLoadStateInitialState,
	...appStateV2InitialState,
	...actionPlanStateV2InitialState,
	...mainInitialState,
	[ROOT_SLICE_ACTION_PLAN_READINGS]: {
		...ActionPlanReadingsInitialState
	},
	[ROOT_SLICE_ACTION_PLAN_SYNC]: {
		...ActionPlanSycnInitialState
	},
	[ROOT_SLICE_ACTION_PLAN_MESSAGES]: {
		...ActionPlanMessagesInitialState
	},
	[ROOT_SLICE_STORE_YMIN_YMAX]: {
		...StoreXYMinMaxInitialState
	},
	[ROOT_SLICE_READINGS_STORE]: {
		...ReadingsStoreInitialState
	}
};

const reducerParts = {
	...chartsSettingsReducerParts,
	...pageLoadStateReducerParts,
	...appStateV2ReducerParts,
	...actionPlanStateV2ReducerParts,
	...mainReducerParts,
	...ActionPlanReadingsReducerParts,
	...ActionPlanSyncReducerParts,
	...ActionPlanMessagesReducerParts,
	...StoreXYMinMaxReducerParts,
	...ReadingsStoreReducerParts,

	[resetScanlineState]: () => {
		return { ...initialState, stateResetUuid: goodEnoughUUID() };
	}
};

export default handleActions(reducerParts, initialState);
